<template>
  <div :class="prefixCls">
    <Modal
      v-model="model"
      :class-name="app.className"
      :title="app.title"
      :width="app.width"
      :footer-hide="app.footerHide"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <slot></slot>
      <div slot="footer" class="zDialog-footer">
        <!-- 当编辑项目的时候底部按钮 -->
        <i
          v-if="app.projectDetail && !app.projectDetail.isOpen && app.permission && app.permission.delete"
          @click="deleteProject"
          class="iconfont icon-shanchu delete-edit-project"
        ></i>
        <Button
          v-if="app.projectDetail && app.permission.end && app.permission && app.permission.start"
          type="primary"
          class="red-btn"
          @click="projectSwitchHandle"
        >{{app.projectDetail.isOpen ? '结束项目' : '开启项目'}}</Button>
        <Button v-if="app.cel" size="large" @click="cancel" :long="app.long">取消</Button>
        <Button
          :disabled="app.bookInfo && app.bookInfo.length === 0"
          :class="app.projectDetail ? 'dark': 'red'"
          type="primary"
          size="large"
          :long="app.long"
          :loading="app.loading"
          @click="ok"
        >{{app.btnTxt}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
const prefixCls = "zDialog";
import Emitter from "../../mixins/emitter.js";
export default {
  name: "ZDialog",
  inject: ["app"],
  mixins: [Emitter],
  data() {
    return {
      prefixCls: prefixCls,
      modelSon: false,
      model: false
    };
  },
  methods: {
    op() {
      this.model = true;
    },
    close() {
      this.model = false;
    },
    ok() {
      this.$emit("submit");
    },
    cancel() {
      this.$emit("close");
      this.close();
    },
    /* 删除项目 */
    deleteProject() {
      this.$emit("delete");
    },
    /* 项目开关 */
    projectSwitchHandle() {
      this.$emit("projectSwitch");
    }
  },
  watch: {
    model: function() {
      this.modelSon = this.model;
    }
  }
};
</script>
<style lang="scss">
.zDialog-footer {
  position: relative;
}
i.delete-edit-project {
  position: absolute;
  left: 33px;
  top: 7px;
  color: #fff;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  background: #e56a69;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
button.dark {
  background: #000 !important;
  border-color: #000 !important;
  &:hover {
    opacity: 0.8;
  }
}

/* 弹框按钮样式覆盖 */
button.red {
  background: #e56a69 !important;
  border-color: #e56a69 !important;
  &:hover {
    opacity: 0.8;
  }
}
</style>


